import { Button } from 'bench-internal-theme';
import { ClientIdContext } from 'bk-web-app';
import React from 'react';
import { ApolloClient } from '@apollo/client';
import { withApollo } from '@apollo/client/react/hoc';

import type { DateRange } from './types';
import { GET_BALANCE_SHEET_REPORT, GET_INCOME_STATEMENT_REPORT } from './queries';
import ledgerAccountCategoryTypes from './ledgerAccountCategoryTypes';

type RefreshBalanceButtonContainerProps = {
  client?: ApolloClient<any>;
  date?: string;
  dateRange?: DateRange;
  ledgerAccountCategoryType: keyof typeof ledgerAccountCategoryTypes;
};

const RefreshBalanceButtonContainer = ({
  client: apolloClient,
  date,
  dateRange,
  ledgerAccountCategoryType,
}: RefreshBalanceButtonContainerProps) => (
  <ClientIdContext.Consumer>
    {clientId => (
      <Button
        icon="refresh"
        onClick={() => {
          let query;
          let variables;
          if (ledgerAccountCategoryType === ledgerAccountCategoryTypes.BALANCE_SHEET) {
            if (!date) {
              return;
            }
            query = GET_BALANCE_SHEET_REPORT;
            variables = { clientId, date };
          }
          if (ledgerAccountCategoryType === ledgerAccountCategoryTypes.INCOME_STATEMENT) {
            if (!dateRange || !dateRange.startDate || !dateRange.endDate) {
              return;
            }
            query = GET_INCOME_STATEMENT_REPORT;
            variables = { clientId, fromDate: dateRange.startDate, toDate: dateRange.endDate };
          }
          if (!query || !variables) {
            return;
          }
          apolloClient?.query({ fetchPolicy: 'network-only', query, variables });
        }}
        size="xsmall"
        styleType="total-ghost"
        title="Recalculate Balance"
      />
    )}
  </ClientIdContext.Consumer>
);

RefreshBalanceButtonContainer.defaultProps = {
  date: undefined,
  dateRange: undefined,
};

export default withApollo<RefreshBalanceButtonContainerProps>(RefreshBalanceButtonContainer);
